import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList, rUstBilgi, rValue } from '../../models/.catalog';

export default class GrupSirketiUstBilgiApi extends ApiBase<pList, rValue<rUstBilgi>> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/GrupSirketiUstBilgi',
      }),
      options
    );
  }
}
